import { render, staticRenderFns } from "./ChangeImgContent.vue?vue&type=template&id=6212f0fc"
import script from "./ChangeImgContent.vue?vue&type=script&lang=js"
export * from "./ChangeImgContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports